import { render, staticRenderFns } from "./ContractStrategicImportances.vue?vue&type=template&id=4234e0a0&"
import script from "./ContractStrategicImportances.vue?vue&type=script&lang=js&"
export * from "./ContractStrategicImportances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports